import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { NotificationsService } from '../../services/notification.service';

@Component({
  selector: 'ara-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  isVisible: boolean = false;
  modules: any[] = [];

  constructor(private commonService: CommonService,private notificationsService:NotificationsService) { }

  ngOnInit() {
    this.GetFAQDetails();
  }

  GetFAQDetails() {
    this.commonService.getFAQDetails({}, this.callbackMethodForGetFAQDetails.bind(this));
  }
  callbackMethodForGetFAQDetails(response) {
    if (response.Success) {
      this.modules = response.Result;
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. FAQ Data Load Problem"
      );
    }
  }
  onClickedOutside() {
    this.isVisible = false;
  }
  toggleTab(module){
    this.modules.forEach(m=> {
      if(m.ModuleName != module.ModuleName){
        m.Selected = false;
      }
      else{
        m.Selected = true;
      }
    })
  }
}
